import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 8 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.995 16q-1.662 0-2.828-1.17Q0 13.66 0 12q0-.94.375-1.75Q.75 9.437 1.5 8.896V2.5q0-1.042.73-1.77A2.4 2.4 0 0 1 4 0a2.4 2.4 0 0 1 1.77.73q.73.728.73 1.77v6.396q.73.541 1.115 1.364A4.1 4.1 0 0 1 8 12q0 1.66-1.171 2.83T3.995 16M3 7h2V6H4V5h1V4H4V3h1v-.5a.97.97 0 0 0-.287-.712A.97.97 0 0 0 4 1.5a.97.97 0 0 0-.713.288A.97.97 0 0 0 3 2.5z"
    }, null, -1)
  ]))]))
}
export default { render: render }